import { useTranslation } from 'react-i18next';

import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

const BaseUrl = ({ ...props }) => {
	const { t } = useTranslation();

	return (
		<FormItem label="baseURL" {...props} required>
			<StringInput name="baseUrl" placeholder={t('fieldPlaceholder', { name: t(props.label || 'baseURL') })} />
		</FormItem>
	);
};

export default BaseUrl;
